import { combineReducers } from 'redux';

import wearablesDashboardUiReducer from './wearablesDashboardUiReducer';
import wearablesDashboardDataReducer from './wearablesDashboardDataReducer';

export default combineReducers({
  ui: wearablesDashboardUiReducer,
  data: wearablesDashboardDataReducer,
});
